import vendorService from "../../../../services/procurementService/vendorService";
import { CACHE_KEY_VENDORS } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VendorInterface } from "../../../../models/ProcurementModule/Vendor";

interface AddVendorContext {
  previousVendors: VendorInterface[];
}

const useAddVendors = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<VendorInterface, Error, VendorInterface, AddVendorContext>(
    {
      mutationFn: vendorService.Create,

      onMutate: () => {
        const previousVendors =
          queryClient.getQueryData<VendorInterface[]>([
            CACHE_KEY_VENDORS,
            page,
            pageSize,
          ]) || [];

        return { previousVendors };
      },

      onSuccess: (savedVendor) => {
        queryClient.setQueryData<VendorInterface[]>(
          [CACHE_KEY_VENDORS, page, pageSize],
          (vendors) => (vendors ? [savedVendor, ...vendors] : [savedVendor])
        );
      },

      onError: (error, newVendor, context) => {
        if (!context) return;

        queryClient.setQueryData<VendorInterface[]>(
          [CACHE_KEY_VENDORS, page, pageSize],
          context.previousVendors
        );
      },
    }
  );
};

export default useAddVendors;
